import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77d645a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "使用可能なPCソフトを教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "OS（複数選択可）")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_2" }
const _hoisted_8 = { class: "entry_career_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ソフト（複数選択可）")
], -1))
const _hoisted_10 = { class: "entry_career_input_layout_column_1" }
const _hoisted_11 = { class: "entry_career_button" }
const _hoisted_12 = { class: "entry_career_button_prev" }
const _hoisted_13 = { class: "entry_career_button_next" }
const _hoisted_14 = { class: "entry_career_skip" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

import Indicator from '@/components/Indicator.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import Loading from '@/components/Loading.vue';
import { getUsableSoftware, putUsableSoftware } from '@/api/careersheetEndpoint';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkillsoftwareView',
  setup(__props) {

const isLoading = ref(false);
const init = async () => {
  isLoading.value = true;
  try {
    const res = await getUsableSoftware();
    osWindowsFlg.value = res.osWindowsFlg || false;
    osMacFlg.value = res.osMacFlg || false;
    osUnixFlg.value = res.osUnixFlg || false;
    msWordFlg.value = res.msWordFlg || false;
    msExcelFlg.value = res.msExcelFlg || false;
    msPowerpointFlg.value = res.msPowerpointFlg || false;
    msAccessFlg.value = res.msAccessFlg || false;
    photoshopFlg.value = res.photoshopFlg || false;
    illustratorFlg.value = res.illustratorFlg || false;
    inDesignFlg.value = res.inDesignFlg || false;
    dreamweaverFlg.value = res.dreamweaverFlg || false;
    adobeXDFlg.value = res.adobeXDFlg || false;
    sketchFlg.value = res.sketchFlg || false;
    figmaFlg.value = res.figmaFlg || false;
    afterEffectsFlg.value = res.afterEffectsFlg || false;
    lightroomFlg.value = res.lightroomFlg || false;
    premiereFlg.value = res.premiereFlg || false;
    finalCutProFlg.value = res.finalCutProFlg || false;
    ediusFlg.value = res.ediusFlg || false;
    unityFlg.value = res.unityFlg || false;
    threeDCgFlg.value = res.threeDCgFlg || false;
    cadFlg.value = res.cadFlg || false;
    googleAnalyticsFlg.value = res.googleAnalyticsFlg || false;
    googleSearchConsoleFlg.value = res.googleSearchConsoleFlg || false;
    biFlg.value = res.biFlg || false;
    statisticalAnalysisFlg.value = res.statisticalAnalysisFlg || false;
    sfaFlg.value = res.sfaFlg || false;
    maFlg.value = res.maFlg || false;
    cloudPlatFormFlg.value = res.cloudPlatFormFlg || false;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const osWindowsFlg = ref(false);
const osMacFlg = ref(false);
const osUnixFlg = ref(false);
const msWordFlg = ref(false);
const msExcelFlg = ref(false);
const msPowerpointFlg = ref(false);
const msAccessFlg = ref(false);
const photoshopFlg = ref(false);
const illustratorFlg = ref(false);
const inDesignFlg = ref(false);
const dreamweaverFlg = ref(false);
const adobeXDFlg = ref(false);
const sketchFlg = ref(false);
const figmaFlg = ref(false);
const afterEffectsFlg = ref(false);
const lightroomFlg = ref(false);
const premiereFlg = ref(false);
const finalCutProFlg = ref(false);
const ediusFlg = ref(false);
const unityFlg = ref(false);
const threeDCgFlg = ref(false);
const cadFlg = ref(false);
const googleAnalyticsFlg = ref(false);
const googleSearchConsoleFlg = ref(false);
const biFlg = ref(false);
const statisticalAnalysisFlg = ref(false);
const sfaFlg = ref(false);
const maFlg = ref(false);
const cloudPlatFormFlg = ref(false);

const usableSoftwareList = ref([
  { label: 'Windows', value: osWindowsFlg },
  { label: 'Mac', value: osMacFlg },
  { label: 'Unix', value: osUnixFlg },
  { label: 'Microsoft Word', value: msWordFlg },
  { label: 'Microsoft Excel', value: msExcelFlg },
  { label: 'Microsoft Powerpoint', value: msPowerpointFlg },
  { label: 'Microsoft Access', value: msAccessFlg },
  { label: 'Photoshop', value: photoshopFlg },
  { label: 'Illustrator', value: illustratorFlg },
  { label: 'InDesign', value: inDesignFlg },
  { label: 'Dreamweaver', value: dreamweaverFlg },
  { label: 'AdobeXD', value: adobeXDFlg },
  { label: 'Sketch', value: sketchFlg },
  { label: 'Figma', value: figmaFlg },
  { label: 'AfterEffects', value: afterEffectsFlg },
  { label: 'Lightroom', value: lightroomFlg },
  { label: 'Premiere', value: premiereFlg },
  { label: 'FinalCutPro', value: finalCutProFlg },
  { label: 'EDIUS', value: ediusFlg },
  { label: 'Unity', value: unityFlg },
  { label: '3DCG（3ds Max、Maya、STRATAなど）', value: threeDCgFlg },
  { label: 'CAD（shade、Vectorworksなど）', value: cadFlg },
  { label: 'Google Analytics', value: googleAnalyticsFlg },
  { label: 'Google Search Console', value: googleSearchConsoleFlg },
  { label: 'BIツール（Tableau、QlikViewなど）', value: biFlg },
  { label: '統計解析ツール（SPSS、SAS、JMPなど）', value: statisticalAnalysisFlg },
  { label: 'SFAツール（Salesforceなど）', value: sfaFlg },
  { label: 'MAツール（Pardot、Marketoなど）', value: maFlg },
  { label: 'クラウドプラットフォーム（AWS、GCP、Azureなど）', value: cloudPlatFormFlg },
]);
const usableSoftwareOSList = computed(() => {
  return usableSoftwareList.value.slice(0, 3);
});
const usableSoftwareSoftList = computed(() => {
  return usableSoftwareList.value.slice(3);
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c08' });
};
const submit = async () => {
  isLoading.value = true;
  try {
    await putUsableSoftware({
      osWindowsFlg: osWindowsFlg.value,
      osMacFlg: osMacFlg.value,
      osUnixFlg: osUnixFlg.value,
      msWordFlg: msWordFlg.value,
      msExcelFlg: msExcelFlg.value,
      msPowerpointFlg: msPowerpointFlg.value,
      msAccessFlg: msAccessFlg.value,
      photoshopFlg: photoshopFlg.value,
      illustratorFlg: illustratorFlg.value,
      inDesignFlg: inDesignFlg.value,
      dreamweaverFlg: dreamweaverFlg.value,
      adobeXDFlg: adobeXDFlg.value,
      sketchFlg: sketchFlg.value,
      figmaFlg: figmaFlg.value,
      afterEffectsFlg: afterEffectsFlg.value,
      lightroomFlg: lightroomFlg.value,
      premiereFlg: premiereFlg.value,
      finalCutProFlg: finalCutProFlg.value,
      ediusFlg: ediusFlg.value,
      unityFlg: unityFlg.value,
      threeDCgFlg: threeDCgFlg.value,
      cadFlg: cadFlg.value,
      googleAnalyticsFlg: googleAnalyticsFlg.value,
      googleSearchConsoleFlg: googleSearchConsoleFlg.value,
      biFlg: biFlg.value,
      statisticalAnalysisFlg: statisticalAnalysisFlg.value,
      sfaFlg: sfaFlg.value,
      maFlg: maFlg.value,
      cloudPlatFormFlg: cloudPlatFormFlg.value,
    });
    router.push({ name: 'c10' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 8,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usableSoftwareOSList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "entry_career_input_layout_column_2_item"
            }, [
              _createVNode(BaseCheckbox, {
                value: false,
                label: item.label,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usableSoftwareSoftList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "entry_career_input_layout_column_1_item"
            }, [
              _createVNode(BaseCheckbox, {
                value: false,
                label: item.label,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            onClick: submit,
            theme: "primary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存して次へ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})